import React from 'react'
import {toAbsoluteUrl} from '../../../../_metronic/helpers'

type Props = {
  loading?: boolean
  onClick: () => void
}

export const NotifyButton: React.FC<Props> = ({loading, onClick}) => (
  <button type='button' className='opi-notify-btn' disabled={loading} onClick={onClick}>
    <img src={toAbsoluteUrl('/media/icons/opi/notify.svg')} alt='' />
    {loading ? 'Sending…' : 'Notify'}
  </button>
)
